///////////////////////////////////////////////////////////////////////////////
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
///////////////////////////////////////////////////////////////////////////////
import 'es6-promise/auto'
import Vue from 'vue'
import router from './router'
import VueResource from 'vue-resource'
///////////////////////////////////////////////////////////////////////////////
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faUserSecret, faPlus, faRubleSign, faPiggyBank, faExclamationCircle,
	faLock, faChevronDown, faTimes, faTimesCircle, faDollarSign, faExchangeAlt,
	faClock, faAsterisk, faCheck, faCheckCircle, faEnvelope, faLink, faEject,
	faArrowRight, faArrowDown, faHdd, faTrash, faTrashAlt, faPencilAlt, faListAlt,
	faList, faListUl, faBars, faEllipsisV, faRandom, faEye, faEyeSlash, faTerminal,
	faRedo, faCompactDisc, faPlayCircle, faVolumeUp, faVolumeMute, faFilter,
	faChevronRight, faQuestionCircle, faLongArrowAltUp, faLongArrowAltDown,
	faPlay, faStop, faUpload, faCircle, faClone, faThumbtack, faCalendarAlt,
	faSun, faUsers, faHandshake, faServer, faPowerOff, faTasks, faHistory,
	faBan, faCompressAlt, faUserCircle, faTrophy, faFileDownload, faShare,
	faShareSquare, faFileInvoice, faBriefcase, faGift, faUserGraduate, faCopy,
	faArrowLeft, faInfoCircle, faQuoteRight, faPlusCircle, faGlobeAmericas,
	faPaperclip, faImage, faCut, faDownload, faCaretSquareRight, faHourglassHalf,
	faThumbsUp, faThumbsDown, faSearch, faCommentDollar, faUniversalAccess, faGripVertical,
	faCloudDownloadAlt, faSearchDollar, faNetworkWired, faClipboard, faFileCsv
	} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

library.add([
	faUserSecret, faPlus, faRubleSign, faPiggyBank, faExclamationCircle,
	faLock, faChevronDown, faTimes, faTimesCircle, faDollarSign, faExchangeAlt,
	faClock, faAsterisk, faCheck, faCheckCircle, faEnvelope, faLink, faEject,
	faArrowRight, faArrowDown, faHdd, faTrash, faTrashAlt, faPencilAlt, faListAlt,
	faList, faListUl, faBars, faEllipsisV, faRandom, faEye, faEyeSlash, faTerminal,
	faRedo, faCompactDisc, faPlayCircle, faVolumeUp, faVolumeMute, faFilter,
	faChevronRight, faQuestionCircle, faLongArrowAltUp, faLongArrowAltDown,
	faPlay, faStop, faUpload, faCircle, faClone, faThumbtack, faCalendarAlt,
	faSun, faUsers, faHandshake, faServer, faPowerOff, faTasks, faHistory,
	faBan, faCompressAlt, faUserCircle, faTrophy, faFileDownload, faShare,
	faShareSquare, faFileInvoice, faBriefcase, faGift, faUserGraduate, faCopy,
	faArrowLeft, faInfoCircle, faQuoteRight, faPlusCircle, faGlobeAmericas,
	faPaperclip, faImage, faCut, faDownload, faCaretSquareRight, faHourglassHalf,
	faThumbsUp, faThumbsDown, faSearch, faCommentDollar, faUniversalAccess, faGripVertical,
	faCloudDownloadAlt, faSearchDollar, faNetworkWired, faClipboard, faFileCsv
])
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
///////////////////////////////////////////////////////////////////////////////
import store from './store'
import localePlugin from './plugins/locale.js'
import formsPlugin from './plugins/forms.js'
import formaterPlugin from './plugins/formater.js'
import Helper from './helper/helper.js'
///////////////////////////////////////////////////////////////////////////////
import App from './App'
///////////////////////////////////////////////////////////////////////////////
Vue.config.productionTip = false
///////////////////////////////////////////////////////////////////////////////
Vue.use(VueResource)
Vue.use(localePlugin)
Vue.use(formsPlugin)
Vue.use(formaterPlugin)
///////////////////////////////////////////////////////////////////////////////
// логер в консоле
///////////////////////////////////////////////////////////////////////////////
window.DEBUG = (function() {
	function _log(str) {
		let _dt = (new Date()).toLocaleTimeString()
		console.log('[DEBUG ' + _dt + '] ' + str)
	}

	function _error(str) {
		let _dt = (new Date()).toLocaleTimeString()
		console.error('[DEBUG ' + _dt + '] ' + str)
	}

	return {
		log: _log,
		error: _error
	}
})()
///////////////////////////////////////////////////////////////////////////////
// узнаем сохраненную в куке локаль
///////////////////////////////////////////////////////////////////////////////
let _locale = Helper.getCookie('ln')
if (!_locale) _locale = 'ru'
// сохраним в хранилище
store.commit('setLang', _locale)
///////////////////////////////////////////////////////////////////////////////
/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: { App }
})
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/main.js